"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-wrap gap-6 justify-center">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm text-foreground-dark hover:text-accent transition-colors duration-500 hover:underline underline-offset-4">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-dark-background text-foreground-dark py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center gap-6">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1516646/img/km_mechanical_services_logo.png" alt="K&M Mechanical Services" className="h-7" />

          <div className="flex gap-4">
            <Link to="https://facebook.com" newTab className="text-foreground-dark hover:text-secondary transition-colors duration-500" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://twitter.com" newTab className="text-foreground-dark hover:text-secondary transition-colors duration-500" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
            <Link to="https://instagram.com" newTab className="text-foreground-dark hover:text-secondary transition-colors duration-500" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
            <Link to="https://linkedin.com" newTab className="text-foreground-dark hover:text-secondary transition-colors duration-500" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
          </div>

          <MenuProvider menu_id="14">
            <FooterMenuConsumer />
          </MenuProvider>

          <p className="text-sm text-center text-foreground-dark/80">
            &copy; {currentYear} K&M Mechanical Services. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}